import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsBrainBreaksLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} brainBreak
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsBrainBreaksLinkState */

/**
 * @extends {ShapeComponent<ComponentsBrainBreaksLinkProps, ComponentsBrainBreaksLinkState>}
 */
class ComponentsBrainBreaksLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    brainBreak: instanceOfClassName("BrainBreak").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, brainBreak, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--brain-breaks--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || brainBreak.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || brainBreak.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, brainBreak} = this.p

    if (adminLayout) return Routes.adminBrainBreakPath(brainBreak.id())
  }
}

export default memo(shapeComponent(ComponentsBrainBreaksLink))
